import { Link } from 'react-router-dom'
import { PartyListItem, PartyStatus } from '../lib/api'

const statusColors: Record<PartyStatus, string> = {
  waiting: 'bg-yellow-100 text-yellow-800',
  active: 'bg-green-100 text-green-800',
  paused: 'bg-orange-100 text-orange-800',
  stopped: 'bg-red-100 text-red-800',
  ended: 'bg-gray-100 text-gray-600',
}

interface PartyCardProps {
  party: PartyListItem
  onEnd?: (id: string) => void
}

export default function PartyCard({ party, onEnd }: PartyCardProps) {
  const handleEnd = () => {
    if (onEnd && confirm(`End party "${party.name}"?`)) {
      onEnd(party.id)
    }
  }

  return (
    <div className="bg-white rounded-lg shadow p-5">
      <div className="flex items-start justify-between">
        <Link to={`/parties/${party.id}`} className="text-lg font-semibold text-gray-900 hover:text-brand-600">
          {party.name}
        </Link>
        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${statusColors[party.status]}`}>
          {party.status}
        </span>
      </div>

      <div className="mt-3 space-y-1 text-sm text-gray-500">
        <div className="flex justify-between">
          <span>Join Code</span>
          <span className="font-mono font-medium text-gray-900">{party.code}</span>
        </div>
        <div className="flex justify-between">
          <span>Participants</span>
          <span>{party.participant_count} / {party.max_participants}</span>
        </div>
        <div className="flex justify-between">
          <span>Created</span>
          <span>{new Date(party.created_at).toLocaleDateString()}</span>
        </div>
        {party.ended_at && (
          <div className="flex justify-between">
            <span>Ended</span>
            <span>{new Date(party.ended_at).toLocaleDateString()}</span>
          </div>
        )}
      </div>

      {party.status !== 'ended' && onEnd && (
        <div className="mt-4 pt-3 border-t border-gray-100">
          <button
            onClick={handleEnd}
            className="text-sm text-red-600 hover:text-red-800 font-medium"
          >
            End Party
          </button>
        </div>
      )}
    </div>
  )
}
